import * as actionTypes from '../consts/actionTypes';

export const localizationAction = context => {
    context.store.dispatch({
        type: actionTypes.setLocalization,
        payload: { localizationSlug: context.params['0'] },
    });
    return context.next();
};
